import { useState } from 'react';
import styled from 'styled-components';
import { Add16, Delete } from 'ui/icons';
import { GhostSuccessButton, GhostButton } from 'ui/button';
import { spacing } from 'ui/theme';
import { AceEditor } from 'modules/aceEditor';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { EmailContentDefinition } from 'modules/graphql';

const DISPLAY_CONTENT = {
  addRawButton: 'Add raw data',
  removeRawButton: 'Remove raw data',
};

const StyledAddIcon = styled(Add16)`
  margin-right: ${spacing.threeQuarter};
`;

export const CustomPayloadField = () => {
  const { liveTemplate, setCurrentMediumField } = useEditableFieldsContext();
  const { payload } = liveTemplate.mediumData as EmailContentDefinition;

  const [rawDataActive, setRawDataActive] = useState(payload !== '{}' && payload !== null);

  const handleRemoveRawData = () => {
    setRawDataActive(false);
    setCurrentMediumField('payload', null);
  };

  const handleResetRawData = () => {
    setCurrentMediumField('payload', '{}');
    setRawDataActive(true);
  };

  const handleJsonData = (json: string) => {
    setCurrentMediumField('payload', json);
  };

  return (
    <>
      {!rawDataActive ? (
        <GhostSuccessButton
          data-test={'custom-payload-field-add-raw-button'}
          onClick={handleResetRawData}
        >
          <StyledAddIcon />
          {DISPLAY_CONTENT.addRawButton}
        </GhostSuccessButton>
      ) : (
        <>
          <AceEditor
            data-test={'custom-payload-field-ace-editor'}
            editorProps={{
              $blockScrolling: Infinity,
            }}
            height="230px"
            mode="json"
            onChange={handleJsonData}
            value={payload ?? '{}'}
            wrapEnabled
          />
          <GhostButton
            data-test={'custom-payload-field-remove-raw-button'}
            onClick={handleRemoveRawData}
          >
            <Delete />
            {DISPLAY_CONTENT.removeRawButton}
          </GhostButton>
        </>
      )}
    </>
  );
};
